const TopNavBarSpan = ({ topTab, setTopTab, tabName, tabText }) => {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        cursor: "pointer",
        padding: "0 1vw",
        fontWeight: topTab === tabName ? "bold" : "normal",
        borderBottom: topTab === tabName ? "2px solid #000" : "none",
        height: "100%",
      }}
      onClick={() => {
        setTopTab(tabName);
      }}
    >
      {tabText}
    </div>
  );
};

export default TopNavBarSpan;
